export const CUSTOM_DOCUMENT_TYPE_LABEL_MAX_LENGTH = 80;
export const CUSTOM_DOCUMENT_TYPE_KEY_MAX_LENGTH = 80;
export const CUSTOM_DOCUMENT_TYPE_ANALYSIS_INSTRUCTION_MAX_LENGTH = 1000;
export const MAX_CUSTOM_DOCUMENT_TYPE = 150;
